import * as actions from '../constants/ActionTypes';

const initialState = {
  MESSAGECENTER_TYPE: '1',
  PAGINATION_CURRENT: 1,
  PAGINATION_TOTAL: 0,
  MYMESSAGE_DATASOURCE: [],
  INFO_DATASOURCE: [],
  HASNEWMESSAGE: 0,
  HASNEWINFO:0
}

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case actions.MESSAGECENTER.MESSAGECENTER_TYPE:
      return Object.assign({}, state, {
        MESSAGECENTER_TYPE: action.MESSAGECENTER_TYPE
      });
    case actions.MESSAGECENTER.PAGINATION_TOTAL:
      return Object.assign({}, state, {
        PAGINATION_TOTAL: action.PAGINATION_TOTAL
      });
    case actions.MESSAGECENTER.PAGINATION_CURRENT:
      return Object.assign({}, state, {
        PAGINATION_CURRENT: action.PAGINATION_CURRENT
      });
    case actions.MESSAGECENTER.MYMESSAGE_DATASOURCE:
      return Object.assign({}, state, {
        MYMESSAGE_DATASOURCE: action.MYMESSAGE_DATASOURCE
      })
    case actions.MESSAGECENTER.INFO_DATASOURCE:
      return Object.assign({}, state, {
        INFO_DATASOURCE: action.INFO_DATASOURCE
      })
    case actions.MESSAGECENTER.HASNEWMESSAGE:
      return Object.assign({}, state, {
        HASNEWMESSAGE: action.HASNEWMESSAGE
      })
      case actions.MESSAGECENTER.HASNEWINFO:
        return Object.assign({}, state, {
          HASNEWINFO: action.HASNEWINFO
      })
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./common/reducers/messageCenter.js